import { groupBy } from "lodash";
import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchDonations } from "../actions/donations";
import { getDonationsData } from "../selectors";

export function getTotalDonations(donation, teamDonations = []) {
  var totalDonations = parseFloat(donation.original_amount);
  const team = teamDonations.find((item) => item.selected_team === donation.selected_team); // prettier-ignore
  if (team) {
    totalDonations += parseFloat(team.original_amount);
  }
  return totalDonations;
}

export function getTeamLeadEmail(selected_team, teams = []) {
  if (!teams || !selected_team) return;
  return teams.find((team) => team.team_name === selected_team).email;
}

export function getRankings(donations = []) {
  const groups = groupBy(donations, "original_amount");
  const keys = Object.keys(groups)
    .map((key) => parseFloat(key))
    .sort((a, b) => b - a);

  const rankings = keys.map((key) => groups[key]);
  rankings.forEach((group, index) => {
    group.forEach((team) => {
      team.rank = index + 1;
    });
  });

  return rankings.flat();
}

export function reduceDonations(data) {
  var teams = [];

  data.reduce((res, value) => {
    if (!res[value.selected_team]) {
      res[value.selected_team] = {
        selected_team: value.selected_team,
        original_amount: 0,
      };
      teams.push(res[value.selected_team]);
    }
    res[value.selected_team].original_amount += parseFloat(
      value.original_amount
    );
    return res;
  }, {});

  return teams;
}

export function useDonations(maxResults, fetchInterval) {
  const dispatch = useDispatch();
  const data = useSelector(getDonationsData);

  useEffect(() => {
    dispatch(fetchDonations());
  }, [dispatch]);

  useEffect(() => {
    let interval = null;

    if (fetchInterval) {
      interval = setInterval(() => {
        dispatch(fetchDonations());
      }, fetchInterval);
    }

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [dispatch, fetchInterval]);

  return useMemo(() => {
    var teams = reduceDonations(data);

    teams.forEach((item, i) => {
      item.id = String(i + 1);
    });

    teams.sort((a, b) => {
      return b.original_amount - a.original_amount;
    });

    teams = teams.map((item) => {
      item.original_amount = Math.round(item.original_amount);
      return item;
    });

    if (maxResults) {
      teams = teams.slice(0, maxResults);
    }

    return teams;
  }, [data, maxResults]);
}
